import React from "react";
import { SERVICE_CHIPS } from "../../utils/constants";
import { emptySpecRow } from "../../utils/jobOrderForm";

const SPEC_COLUMNS = [
  { key: "quantity", label: "Quantity", width: "12%", placeholder: "e.g. 100 Pcs" },
  { key: "dimensions", label: "Size / Dimensions", width: "20%", placeholder: "e.g. A4 / 21x29cm" },
  { key: "material", label: "Material", width: "20%", placeholder: "e.g. 350gsm Matte" },
  { key: "color", label: "Color / Finish", width: "20%", placeholder: "e.g. Full Color 4/4" },
  { key: "artwork", label: "Artwork / File Details", width: "23%", placeholder: "e.g. PDF approved" },
];

/* Step 2 — services, description, itemised specs and deadline. */
export default function StepServices({ form, update, services, active }) {
  const toggleService = (service, checked) => {
    update({
      services: checked ? [...form.services, service] : form.services.filter((s) => s !== service),
    });
  };

  const setItem = (index, key, value) => {
    update({ items: form.items.map((row, i) => (i === index ? { ...row, [key]: value } : row)) });
  };

  const removeItem = (index) => {
    update({ items: form.items.filter((_, i) => i !== index) });
  };

  return (
    <div className={`wizard-step-panel ${active ? "active" : ""}`} id="step-panel-2">
      <div className="panel-section-title">
        <span className="section-badge">2</span> Service / Job Type &amp; Specifications
      </div>

      <div className="form-group">
        <label className="section-sublabel">Select Service / Job Types (Select all that apply):</label>
        <div className="checkbox-chips-grid">
          {services.map((service) => (
            <label className="chip-item" key={service}>
              <input
                type="checkbox"
                name="services"
                value={service}
                checked={form.services.includes(service)}
                onChange={(e) => toggleService(service, e.target.checked)}
              />
              <span className="chip-box">{SERVICE_CHIPS[service] || service}</span>
            </label>
          ))}
        </div>
        {form.services.includes("Other") && (
          <div className="form-group mt-2">
            <input
              type="text"
              id="input-service_other"
              placeholder="Specify other service type"
              maxLength={255}
              value={form.service_other}
              onChange={(e) => update({ service_other: e.target.value })}
            />
          </div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="input-job_description">Detailed Job Description / Specifications</label>
        <textarea
          id="input-job_description"
          rows="3"
          placeholder="Provide complete specifications, scopes, artwork instructions, colors, etc."
          value={form.job_description}
          onChange={(e) => update({ job_description: e.target.value })}
        ></textarea>
      </div>

      <div className="form-group">
        <div className="items-table-header">
          <label className="section-sublabel">Itemized Job Specifications &amp; Quantities:</label>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            disabled={form.items.length >= 50}
            onClick={() => update({ items: [...form.items, emptySpecRow()] })}
          >
            + Add Item Row
          </button>
        </div>
        <div className="specs-table-wrapper">
          <table className="specs-input-table">
            <thead>
              <tr>
                {SPEC_COLUMNS.map((col) => (
                  <th key={col.key} style={{ width: col.width }}>
                    {col.label}
                  </th>
                ))}
                <th style={{ width: "5%" }}></th>
              </tr>
            </thead>
            <tbody>
              {form.items.map((row, index) => (
                <tr key={index}>
                  {SPEC_COLUMNS.map((col) => (
                    <td key={col.key}>
                      <input
                        type="text"
                        placeholder={col.placeholder}
                        maxLength={255}
                        value={row[col.key]}
                        onChange={(e) => setItem(index, col.key, e.target.value)}
                      />
                    </td>
                  ))}
                  <td className="text-right">
                    <button type="button" className="btn-remove-row" title="Remove Row" onClick={() => removeItem(index)}>
                      &times;
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="form-grid grid-2">
        <div className="form-group">
          <label htmlFor="input-deadline_date">📅 Deadline / Delivery Date</label>
          <input type="date" id="input-deadline_date" value={form.deadline_date} onChange={(e) => update({ deadline_date: e.target.value })} />
        </div>
        <div className="form-group">
          <label htmlFor="input-deadline_time">⏰ Delivery Time</label>
          <input type="time" id="input-deadline_time" value={form.deadline_time} onChange={(e) => update({ deadline_time: e.target.value })} />
        </div>
      </div>
    </div>
  );
}
